import styles from "./Addresses.module.css"
import { useState, useEffect } from 'react';
import SecondaryButton from "../../../../../components/Button/SecondaryButton/SecondaryButton";
import FillInField from "../../../../../components/Input/FillInField/FillInField";
import { useTranslation } from "react-i18next";
import { useUserContext } from "../../../../../context/UserContext";
import { useOrderContext } from "../../../../../context/OrderContext";

/**
* Address page
* Contains all users addresses and a form for making a request to add a new one
* @returns TSX.Element
*/
const AddressPage = () => {
    const { t } = useTranslation(); // Translation
    // States for the inputs
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [postNumber, setPostNumber] = useState("");
    const { userData } = useUserContext();
    const { orderData } = useOrderContext();
    // Fetch adresses
    const [adresses, setAdresses] = useState<string[]>([])
    useEffect(() => {
        const tempAdresses = userData.subscribers?.filter(sub => sub.subscriber_id === orderData.recipient)
            .flatMap(s => s.delivery_adresses.map(a => a.adress)) ?? []
        setAdresses(tempAdresses)
    },[userData])



    return(
        <>
            <div className={styles.AddressPageContent}>
                <p className={styles.AddressPageContentTitle}>{t("account.titles.addresses")}</p>
                <div className={styles.AddressPageContentCenter}>
                    <div className={styles.AddressList}>
                        <p className={styles.AddressListTitle}>{t("account.addresses.base_form_title")}</p>
                        <div className={styles.AddressListContent}>
                            {adresses.map((address, i)=>(
                                    <div className={styles.InfoRow} key={i}>
                                        <FillInField
                                            label={`${t("account.addresses.address")} ${i+1}`}
                                            placeholder={address}
                                            disabled = {true}
                                            className={styles.SetAddress}
                                        />
                                    </div>
                            ))}
                        </div>
                    </div>
                    <div className={styles.NewAddress}>
                        <div className={styles.NewAddressContent}>
                            <p className={styles.NewAddressTitle}>{t("account.addresses.new_address")}</p>
                            <div className={styles.NewAddressInputs}>
                                <div className={`${styles.NewAddressInputGroup} ${styles.GroupWrap}`}>
                                    <FillInField
                                        label={t("account.addresses.inputs.address.title")}
                                        placeholder={`${t("account.addresses.inputs.address.placeholder")}`}
                                        value={address}
                                        onChange={value => setAddress(String(value))}
                                    />
                                    <div className={styles.NewAddressInputGroup}>
                                        <FillInField
                                            label={t("account.addresses.inputs.city.title")}
                                            placeholder={`${t("account.addresses.inputs.city.placeholder")}`}
                                            value={city}
                                            onChange={value => setCity(String(value))}
                                        />
                                        <FillInField
                                            label={t("account.addresses.inputs.post.title")}
                                            placeholder={`${t("account.addresses.inputs.post.placeholder")}`}
                                            value={postNumber}
                                            onChange={value => setPostNumber(String(value))}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                            <SecondaryButton
                            text={t("buttons.new_address")}
                            onClick={()=>alert("clicked")}
                            className={address === "" || city === "" || postNumber === "" ?  `${styles.NewAddressButton} ${styles.Disabled}` :  `${styles.NewAddressButton}`}
                            disabled={address === "" || city === "" || postNumber === ""}
                            />
                    </div>
                </div>
            </div>
        </>
    )
}


export default AddressPage;
